<template>
    <div>
        <v-dialog persistent v-model="dialog" max-width="700" height="400">
            <v-card tile :loading="loading">
                <v-toolbar color="white">
                    <v-toolbar-title class="text-primary">قالب‌های آماده</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn @click="dialog = false" icon>
                        <v-icon color="primary" size="23">close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-divider></v-divider>
                <div class="px-3 mt-5">
                    <v-text-field
                        append-inner-icon="search"
                        label="جستجو"
                        v-model="search"
                    ></v-text-field>
                    <v-expansion-panels flat>
                        <v-expansion-panel color="blue-grey-lighten-5" v-for="item in list.filter(x => !search || x.name.includes(search))">
                            <v-expansion-panel-title>{{ item.name }}</v-expansion-panel-title>
                            <v-expansion-panel-text>
                                <div class="d-flex align-center">
                                    <p class="flex-grow-1 text-small">{{ item.body.replace(/<[^>]*>?/gm, '') }}</p>
                                    <v-btn @click.stop="$emit('submited', item.body); dialog = false;" color="secondary" variant="tonal">
                                        <v-icon color="secondary" size="18">add</v-icon>
                                        <p class="mb-0 ms-1 text-small">انتخاب</p>
                                    </v-btn>
                                </div>
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </div>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
export default {
    data() {
        return {
            loading: false,
            dialog: false,
            list: [],
            search: null,
        };
    },
    watch: {
        dialog() {
            if (!this.list.length) {
                this.loading = true;
                this.$knowledgebaseTemplateList().then(res => {
                    if(res && res.status == "OK")
                        this.list = res.data.map(x => {return {...x, showBody: false}});
                }).finally(() => this.loading = false);
            }
        }
    }
};
</script>
